import React, { useState, useEffect, useMemo } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import { Tooltip } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Pagination from '@mui/material/Pagination';
import MSelect from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
import Loader from "./../../CommonLoader";
import CommonAlert from "../../../../Commonalert/commonalert";
import DatagridComp from "../../DatagridComp";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";

export default function Missingcanonical(props) {
  const [cardData, setCardData] = useState([]);
  const [missingData, setMissingData] = useState("")
  const [loading, setLoading] = React.useState(false)
  const [autoheightval, SetAutoheightval] = useState(true)
  const navigate = useNavigate();
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const apihandleClose = () => {
    setapiOpen(false);
  };
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  const MyCustomNoRowsOverlay = () => (
    <StyledGridOverlay>
      <svg
        width="120"
        height="100"
        viewBox="0 0 184 152"
        aria-hidden
        focusable="false"
      >
        <g fill="none" fillRule="evenodd">
          <g transform="translate(24 31.67)">
            <ellipse
              className="ant-empty-img-5"
              cx="67.797"
              cy="106.89"
              rx="67.797"
              ry="12.668"
            />
            <path
              className="ant-empty-img-1"
              d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
            />
            <path
              className="ant-empty-img-2"
              d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
            />
            <path
              className="ant-empty-img-3"
              d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
            />
          </g>
          <path
            className="ant-empty-img-3"
            d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
          />
          <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
            <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
            <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
          </g>
        </g>
      </svg>
      <Box sx={{ mt: 1 }}>No Data</Box>
    </StyledGridOverlay>
  );
  useEffect(() => {
    callUserdataApi();
  }, []);
  useEffect(() => {

    if (props.SubmitTriggered === true) {
      callUserdataApi()
    }

  }, [props.SubmitTriggered])
  useEffect(() => {
    callUserdataApi()

  }, [props.domainsection])
  const columns = [

    {
      field: "page_url",
      headerName: "Page URL",
      description: 'URL of the web page',
      minWidth: 600,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (cardData) => {
        let baseUrl = cardData.row.page_url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.page_url.split("/").slice(3).join("/");
        return (
          <>
            <Tooltip title={cardData.row.link__url}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.link__url} style={{ display: "flex", flexDirection: "column" }} >
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span
                    className="spanlink"
                    style={{
                      color: "#044792",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {remaining}
                  </span>
                </a>
              </div>
            </Tooltip>
          </>
        );

      },

    },
    {
      field: "canonical_url",
      headerName: "Canonical Url",
      description: 'A mismatch in the Canonical URL for the web page.',
      minWidth: 600,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (cardData) => {
        let baseUrl = cardData.row.canonical_url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.canonical_url.split("/").slice(3).join("/");
        return (
          <>
            <Tooltip title={cardData.row.canonical_url}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.canonical_url} style={{ display: "flex", flexDirection: "column" }} >
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span
                    className="spanlink"
                    style={{
                      color: "#044792",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {remaining}
                  </span>
                </a>
              </div>
            </Tooltip>
          </>
        );

      },

    },
  ];
  const rows = cardData ?? [];

  const callUserdataApi = async (missingdatas) => {
    setLoading(true)
    setCardData([])
    var dataurls = ""
    dataurls = `${process.env.REACT_APP_API_URL}technical/onpagecrawl/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${props.domainsection}&job_id=${props.JobId}&field_type=mismatch_canonical`
    const datavalue = await axios
      .get(
        `${dataurls}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

    const dataval = datavalue?.data?.table?.mismatch_canonical

    if (dataval) {
      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });

      setCardData(newData);
      SetAutoheightval(false)
    }
    else {
      setCardData("");
      SetAutoheightval(true)
    }

    setLoading(false)
    props.SetSubmitTriggered(false)
  };

  return (
    <>
      {loading === true ? <Loader /> : null}
      <div
        style={{
          width: "calc(100% - 40px)",
          marginRight: "40px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >

        <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
        {!openCommonAlerts &&
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
        }
        <DatagridComp
          columns={columns}
          rows={rows}
          autoheightval={autoheightval}
          datagridval={2}
          handleModelPopUp={props.handleModelPopUp}
          handleDownlodingCSV={props.handleDownlodingCSV}
          handleDownlodingPDF={props.handleDownlodingPDF}
          customFilter={true}
          DownloadShowFile={true}
          DownloadShowPDF={1}
          DownloadShowCSV={2}
        />
      </div>
    </>
  );
}
